export enum membership {
   PRO = 'pro' ,
   PRO_SUBS = 'pro_subs',
   LITE = 'lite',
   LITE_DEL = 'lite_del',
   EE_FREE_DIGITAL_MENU_LEADS = 'EE_FreeDigitalMenuLeads'
  }